export default "__VITE_ASSET__DdTkXJ1e__"